export default {
  type: 'detail.Item',
  types: {
    rsrc: {
      type: 'detail.ItemType',
      details: {
        type: 'detail.DetailList',
        footer: {
          visible: false
        },
        header: {
          icon: {
            size: '24px',
            attrName: 'icon'
          },
          primary: {
            font: {
              size: null,
              type: 'style.Font',
              style: null,
              family: null,
              weight: null
            },
            color: null,
            attrName: 'name'
          },
          visible: false,
          controlsVisible: false
        },
        details: [{
          type: 'attr.detail.string',
          label: {
            font: {
              size: null,
              type: 'style.Font',
              style: null,
              family: null,
              weight: null
            },
            name: null,
            wrap: false,
            align: 'center',
            color: null,
            justify: 'left',
            variant: null,
            visible: false
          },
          value: {
            font: {
              size: null,
              type: 'style.Font',
              style: null,
              family: null,
              weight: null
            },
            wrap: true,
            align: 'center',
            color: null,
            justify: 'left',
            variant: {
              type: 'variantizer.Value',
              variant: 'caption'
            },
            visible: {
              type: 'visibilizer.IfEmpty',
              value: true
            },
            emptyValue: '-',
            showIfEmpty: true
          },
          columns: 2,
          visible: true,
          attrName: 'rsrc.path',
          objectType: 'rsrc'
        }, {
          type: 'attr.detail.Generic',
          label: {
            font: {
              size: null,
              type: 'style.Font',
              style: null,
              family: null,
              weight: null
            },
            name: null,
            wrap: false,
            align: 'center',
            color: null,
            justify: 'left',
            variant: null,
            visible: false
          },
          value: {
            font: {
              size: null,
              type: 'style.Font',
              style: null,
              family: null,
              weight: null
            },
            wrap: false,
            align: 'center',
            color: null,
            justify: 'left',
            variant: {
              type: 'variantizer.Value',
              variant: 'caption'
            },
            visible: {
              type: 'visibilizer.IfEmpty',
              value: true
            },
            emptyValue: '-',
            showIfEmpty: true
          },
          columns: 2,
          visible: true,
          attrName: 'rsrc.createdAt',
          formatter: {
            type: 'attr.formatter.timestamp',
            format: 'M/d h:mm a'
          },
          objectType: 'rsrc'
        }],
        variant: 'rsrc',
        background: null,
        labelColor: null,
        valueColor: null,
        suffixColor: null,
        labelVariant: null
      },
      display: null,
      objectType: 'rsrc'
    }
  },
  display: 'block',
  editable: true
};